module.exports = __webpack_public_path__ + "assets/img/vipIcon4.192f1afd.png";